<div fxLayout="column">

  <mat-label>Permissions</mat-label>

  <mat-hint *ngIf="!loadingPermissions && permissions.length === 0" class="color-warn">
    No permissions available.
  </mat-hint>

  <mat-action-list>
    <mat-list-item *ngFor="let permission of permissions"
               (click)="togglePermission(permission.name)"
               [class.disabled]="
                 (permission.name === 'admin' && _user.id === loggedUser?.id) ||
                 (permission.name === 'customer' && currentPermissionsNames.includes('admin'))
               ">
      <div matListItemIcon>
        <mat-spinner mode="indeterminate" diameter="20" *ngIf="loadingPermissionsNames.includes(permission.name)">
        </mat-spinner>
        <ng-container *ngIf="!loadingPermissionsNames.includes(permission.name)">
          <mat-icon *ngIf="currentPermissionsNames.includes(permission.name)" color="primary">
            check_box
          </mat-icon>
          <mat-icon *ngIf="!currentPermissionsNames.includes(permission.name)" color="accent">
            check_box_outline_blank
          </mat-icon>
        </ng-container>

      </div>
      <div matListItemTitle class="uppercase">
        {{ permission.name }}
      </div>
    </mat-list-item>
  </mat-action-list>

  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="done.emit()" color="primary" mat-button>
      Done
    </button>
  </div>

</div>
